<template>
  <div id="app">
    <header-nav v-show="$route.meta.navShow"></header-nav>
    <keep-alive :include="include">
      <router-view />
    </keep-alive>
    <footer-nav v-show="$route.meta.navShow"></footer-nav>
    <aside-pendant
      v-if="!jin_sha_global_login_state"
      v-show="!$route.meta.asideHide"
    ></aside-pendant>
     <C2cPopup/>
    <el-dialog
      custom-class="mask"
      :visible="showSignInActivity"
      :close-on-click-modal="false"
    ></el-dialog>

    <signInIndex
      v-if="showSignInActivity"
      v-show="showSignInActivity"
      v-on:closeWindow="closeSignInActivityHandler"
    />
    <div style="position: absolute; z-index: -1;color: transparent">
      <h1>迷人至极!王李丹妮写真赏：这谁顶得住!女神的魅力无法抵挡! </h1>
      <p>迷人至极！王李丹妮写真赏：这谁顶得住！女神的魅力无法抵挡！



在这个看脸的时代，美女如云，而能够称得上女神的更是凤毛麟角。近日，一位名叫王李丹妮的女子凭借其迷人的外貌和性感的身材，成为了众人瞩目的焦点。她的美丽不仅仅是外表，更是一种内在美的独特气质。那么，究竟是什么让这位女神如此迷人呢？让我们一起来欣赏一下王李丹妮的写真，感受她的魅力吧！



首先，我们不得不提到王李丹妮那堪称完美的身材。她的身材曲线优美，丰满而不臃肿，无论是在舞台上还是生活中，都能够吸引无数目光。这种身材的保持并非一朝一夕之功，而是源于她对锻炼的坚持。据了解，王李丹妮每天都会进行大量的运动，如瑜伽、舞蹈、游泳等，以保持身体的柔韧性和线条美。正是这种对美的执着追求，让她的身材更加婀娜多姿。
</p>
</div>
    <div style="display: none;">
<h1> 刚上任的这两位省级党委书记，调研首站有何讲究？ </h1> 
2024-07-01 09:27 来源: 澎湃新闻 
   
发布于：上海市
据新华社6月28日播发的消息，3名省级党委书记同日履新。

其中，四川省委副书记、省长黄强任吉林省委书记，宁夏回族自治区党委书记梁言顺任安徽省委书记，新疆维吾尔自治区党委副书记、新疆生产建设兵团党委书记、政委李邑飞任宁夏回族自治区党委书记。

目前，其中两位省级党委书记奔赴新岗位后的首次公开调研已经公布。

宁夏：第一站来到闽宁镇

据《宁夏日报》消息，6月28日下午，到任宁夏当天，自治区党委书记李邑飞到银川市闽宁镇、金凤区长城花园社区调研。

报道称，闽宁镇是习近平总书记亲自提议命名、推动建设、授牌表彰的东西部扶贫协作成功典范。李邑飞来到镇史馆，从总书记5次考察宁夏的一张张照片、一幕幕场景、一句句嘱托中，深入了解西海固从苦甲天下到脱贫致富、闽宁镇从“干沙滩”到“金沙滩”的历史变迁，详细询问产业发展、居民收入、民生保障等情况。



李邑飞在银川市永宁县闽宁镇镇史馆参观调研。

他说，我到宁夏工作后调研的第一站来到闽宁镇，就是沿着总书记的足迹，悉心体悟总书记28年来对宁夏人民的深情大爱，深刻感悟总书记重要思想的深厚伟力，从总书记关于脱贫攻坚、东西部协作的重要论述中汲取力量。今天的好日子都是在总书记的带领下奋斗出来的，我们要感恩总书记、感恩共产党，坚定不移沿着总书记指引的康庄大道走下去，统筹推进新型城镇化和乡村振兴，把工作落脚点放在群众增收致富上，稳住富民产业，做活特色产业，进一步巩固拓展脱贫攻坚成果，推动铸牢中华民族共同体意识走深走实。

之后的6月29日至30日，李邑飞到吴忠市红寺堡区和固原市隆德县、西吉县，调研粮食安全、农作物受灾减灾、地质灾害隐患点防治等安全防范情况，参观六盘山红军长征纪念馆和将台堡红军长征会师纪念园。

近日，宁夏部分地区遭受暴雨、冰雹、山洪灾害，造成农作物不同程度受损。

李邑飞首先来到红寺堡区柳泉乡柳泉村，实地察看玉米、黄花菜受灾情况，指出要全面摸清灾情影响，加强作物抢收、应急补种，强化预警监测、防范应对，及时兑现保险赔偿，尽可能把损失降到最低，帮助受灾农户渡过难关。在隆德县陈靳乡民联村，李邑飞详细询问滑坡、泥石流等地质灾害防治情况，现场抽查应急响应并针对问题杀“回马枪”。他强调，人命关天，不能有一点形式主义，更不能有丝毫麻痹大意。要高度警惕“黑天鹅”事件，严密防范“灰犀牛”事件，尤其要关注那些容易被忽视的小部位和不经意冒出来的“小隐患”，有针对性采取系统治理、综合防范措施，全面加强各项安全工作，全力保障群众生命财产安全。
</div>
    <!-- 强制修改密码弹框 -->
    <div v-if="showRepwd" class="forget-box">
      <div class="tip-box">
        <div class="title">修改登录密码</div>
        <div class="tip">
          <img class="icon" src="./assets/images/home/icon/tishi.png" />
          为了您的资金安全，请您立即修改登录密码，设置后可关闭此页
        </div>
        <!-- 修改登录密码表单 -->
        <div class="form-canvas-check">
          <!-- 原密码 -->
          <div class="row old-pwd-canvas">
            <div class="icon">
              <div class="icon-img"></div>
              <!-- <div class="icon-name">原密码</div> -->
              <div class="line"></div>
            </div>

            <div class="input-canvas">
              <el-input
                class="input-margin"
                type="password"
                v-model="password"
                placeholder="请输入旧密码"
              ></el-input>
            </div>
          </div>
          <!-- 新密码 -->
          <div class="row new-pwd-canvas">
            <div class="icon">
              <div class="icon-img"></div>
              <!-- <div class="icon-name">新密码</div> -->
              <div class="line"></div>
            </div>

            <div class="input-canvas">
              <el-input
                class="input-margin"
                type="password"
                v-model="newPassword"
                placeholder="请输入新密码"
              ></el-input>
            </div>
          </div>
          <!-- 确认密码 -->
          <div class="row confirm-pwd-canvas">
            <div class="icon">
              <div class="icon-img"></div>
              <!-- <div class="icon-name">确认密码</div> -->
              <div class="line"></div>
            </div>

            <div class="input-canvas">
              <el-input
                class="input-margin"
                type="password"
                v-model="rePassword"
                placeholder="请再一次输入新密码"
              ></el-input>
            </div>
          </div>

          <div class="btn">
            <el-button
              class="btn-warning"
              @click="keepPwd()"
              :class="{ 'can-active': formIsReady }"
              type="warning"
              >保存</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import HeaderNav from "./components/HeaderNav";
import FooterNav from "./components/footer/footerNav";
import AsidePendant from "./components/pendant/aside-pendant";
import { mapState, mapActions, mapMutations } from "vuex";
import { filter, check, common,commonApi } from "@/common/index";
import { gameMaintain } from "@/common/mixins";
import signInIndex from "./components/signInActivity/signInIndex";
import globalSock from "./mixin/global-sock.js";
import C2cPopup from "./components/c2cPopup/c2cPopup.vue";


export default {
  name: "App",
  mixins: [globalSock,gameMaintain],
  components: {
    C2cPopup,
    AsidePendant,
    HeaderNav,
    FooterNav,
    signInIndex,
  },
  data() {
    return {
      password: "",
      newPassword: "",
      rePassword: "",
      isLoading: false,

      include: [
        "HOME",
        "fish-page",
        "chess-page",
        "liveCasino",
        "lottery-page",
        "sports-page",
        "privilege",
        "discountsHall",
      ],
      timer: "",
    };
  },
  computed: {
    ...mapState({
      showRepwd: (state) => state.showRepwd,
      UUID: (state) => state.UUID,
      isLogin: (state) => state.isLogin,
      jin_sha_global_login_state: (state) => state.jin_sha_global_login_state,
      showSignInActivity: (state) => state.signin_activity_window,
    }),
    //监听表单是否可用
    formIsReady: function () {
      let result =
        this.newPassword.length > 0 &&
        this.rePassword.length > 0 &&
        this.password.length > 0;
      return result;
    },
  },
  methods: {
    ...mapMutations(["setOpenSignInWindow", "setShowRepwd"]),
    ...mapActions([
      "newinitLinkList",
      "initLinkList",
      "getFirstNav",
      "getInEmail",
      "getBonusInfo",
      "getFirstInfo"
    ]),

    // 有agentCodediao
    agentCodeCache(code) {
      commonApi.HOMEBEFORE.agentCodeCache({
        code: code
      }).then(data => {
        console.log(data);
        if (data) {
          this.$Cookies.set("agentCode", data);
        }
      });
    },


    refreshUserInfo() {
      let params = {
        UUID: this.UUID,
      };
      this.$api.post(
        this.$urls.HOMEAFTER.refreshUserInfo,
        params,
        (resp) => {},
        (err) => {}
      );
    },
    IsPC() {
      let userAgentInfo = navigator.userAgent;
      let Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      let flag = true;
      for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    closeSignInActivityHandler() {
      this.setOpenSignInWindow(false);
    },
    //强制更改登录密码
    keepPwd() {
      if (!this.formIsReady || this.isLoading) return;
      let isOk = this.checkForm();
      if (!isOk) return;
      this.updatePwd();
    },
    //更新密码调用
    updatePwd() {
      let params = {
        UUID: this.UUID,
        oldPW: this.password,
        newPW: this.newPassword,
        confirmNew: this.rePassword,
      };

      if (!this.isLoading) {
        this.isLoading = true;
        this.$api.post(
          this.$urls.USER.updateLoginPassword,
          params,
          (resp) => {
            this.isLoading = false;
            if (resp.data.code === 200) {
              setTimeout(() => {
                this.loginOut();
              }, 1000);
              this.setShowRepwd(false);
              this.$message({
                message: "登录密码修改成功！",
                type: "success",
              });
            } else if (resp.data.code === 206) {
              this.$message({
                message: "原始密码错误",
                type: "warning",
              });
            } else {
              this.$message({
                message: resp.data.msg,
                type: "warning",
              });
            }
          },
          (err) => {
            this.isLoading = false;
          }
        );
      }
    },
    loginOut() {
      common
        .loginOut()
        .then((msg) => {
          this.$message({
            message: msg,
            type: "warning",
          });
          this.$router.push({ path: "/home" });
        })
        .catch((err) => {});
    },

    checkForm() {
      let isOK = true;
      let repeatpwd = check.checkConfirm(this.newPassword, this.rePassword);
      let oldnewpwd = check.checkConfirms(this.password, this.rePassword);
      let pwd = check.checkRegisterPassword(this.newPassword);
      //校验密码

      if (pwd) {
        this.$message({
          message: "密码由6-12位数字，字母组成",
          type: "warning",
        });
        isOK = false;
      }
      if (repeatpwd) {
        this.$message({
          message: repeatpwd,
          type: "warning",
        });
        isOK = false;
      }
      if (oldnewpwd) {
        this.$message({
          message: oldnewpwd,
          type: "warning",
        });
        isOK = false;
      }
      return isOK;
    },
  },
  watch: {
    isLogin() {
      if (this.isLogin) {
        commonApi.WALLET.refresh().then(data => {
          this.getFirstInfo();
        }).catch(err => {});
        this.getInEmail();
        this.refreshUserInfo();
        this.timer = setInterval(() => {
          this.refreshUserInfo();
        }, 1000 * 60 * 5);
      } else {
        this.$router.push({ path: "/" });
        clearInterval(this.timer);
        this.timer = "";
      }
    },
  },
  mounted() {
    this.newinitLinkList();
    this.initLinkList();
    this.getFirstNav();
        //获取code
    let agentCode = common.getAgentCode();
    if (agentCode) {
      // 存在邀请码
      this.$Cookies.set("agentCode", agentCode);
      this.agentCodeCache(agentCode);
    } else {
      // 没有就获取下后台
      this.agentCodeCache("");
    }
  },

  created() {
    this.getBonusInfo();
  },
};
</script>

<style lang="scss">
@import "./style/index.scss";
.forget-box {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  .el-input__inner {
    border: none !important;
    height: 60px !important;
    line-height: 60px !important;
    font-size: 20px !important;
  }
  .tip-box {
    width: 745px;
    height: 548px;
    background-color: white;
    border-radius: 20px;
    margin: auto;
    color: #161616;
    .title {
      font-size: 24px;
      font-weight: bold;
      height: 86px;
      line-height: 86px;
      text-align: center;
    }

    .tip {
      height: 42px;
      font-size: 18px;
      background: #fcc245;
      color: #161616;
      text-align: center;
      line-height: 42px;
      margin-bottom: 37px;

      .icon {
        margin-right: 10px;
      }
    }

    //验证页面表单样式
    .form-canvas-check {
      width: 520px;
      height: auto;
      margin: 0 auto;

      // margin: 0 auto;
      .old-pwd-canvas {
        .icon-img {
          background: url("./assets/images/home/icon/oldmima.png") no-repeat
            center center !important;
          background-size: contain !important;
        }
      }
      .input-margin {
        // margin-top: 0.3684rem;
      }
      .row {
        width: 100%;
        height: 60px;
        background: #fff;
        margin-bottom: 20px;
        border-radius: 10px;
        border: 1px solid #949494;
        overflow: hidden;

        .icon {
          position: relative;
          float: left;
          width: 80px;
          height: 60px;

          .icon-img {
            position: absolute;
            width: 30px;
            height: 35px;
            left: 0;
            top: 50%;
            margin-top: -17px;
            margin-left: 20px;
            margin-right: 17px;
            background: url("./assets/images/home/icon/newmima.png") no-repeat
              center center;
            background-size: contain;
          }

          .line {
            position: absolute;
            width: 100%;
            height: 26px;
            top: 50%;
            margin-top: -13px;
            box-sizing: border-box;
            border-right: 1px solid #cccccc;
          }
        }

        .input-canvas {
          position: relative;
          float: right;
          height: 100%;
          width: calc(100% - 80px);
          vertical-align: middle;

          .van-cell-group {
            margin-top: calc(1.26315rem - 22px);
          }

          .van-hairline--top-bottom::after {
            border-width: 0px !important;
          }
        }
      }
    }
    .btn {
      width: 156px;
      margin: 25px auto;
    }
    .btn-warning {
      margin-top: 40px;
      width: 100%;
      height: 52px;
      border-radius: 10px;
      background: #afafaf;
      border: none;
      font-size: 20px;
    }
    .can-active {
      background: linear-gradient(to top, #e89212, #dba615);
    }
  }
}
.no-scroll {
  overflow: hidden;
}

.mask {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/build08/App.vue